import { useState } from "react";
import { FiRefreshCw } from "react-icons/fi";

const ProfileImage = ({ name, onChange, id }) => {
  const [preview, setPreview] = useState(null);
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setPreview(URL.createObjectURL(file));
    if (onChange) onChange(file);
  };
  return (
    <section className="bg-[#182443] py-8 rounded-lg md:w-[300px] self-start">
      <div className="flex flex-col items-center gap-2">
        <label htmlFor="profile" className="relative cursor-pointer">
          <span className="top-[35px] rtl:right-[-10px] ltr:left-[-10px] absolute size-6 border-2 border-primary bg-[#1E4071] rounded-full grid place-content-center">
            <FiRefreshCw size={12} />
          </span>
          <input
            type="file"
            accept="image/*"
            id="profile"
            name={name}
            onChange={handleFileChange}
            className="absolute top-0 left-0 size-0"
          />
          <img
            src={preview || "/assets/team1.jpg"}
            alt="Preview"
            className="object-cover mt-2 rounded-full size-32"
          />
        </label>
      </div>
      <h3 className="my-4 text-xl font-bold text-center">{id}</h3>
      <span className="block my-2 text-xs font-bold text-center text-primary">
        مطور برمجيات
      </span>
      <span className="block w-fit min-w-[100px] text-center mx-auto px-2 py-1 rounded-lg text-[#11A849] bg-[#E6F4EF]">
        نشط
      </span>
    </section>
  );
};

export default ProfileImage;
